import { Component } from '@angular/core';
import { translate } from '@ngneat/transloco';
import { MessageService } from 'primeng/api';
import { Subscription } from 'rxjs';
import { Paginate } from 'src/app/shared/models/paginate.model';
import { User } from 'src/app/shared/models/user/user.model';
import { AuthService } from 'src/app/shared/services/auth.service';
import { environment } from 'src/environments/environment.global';
import {  UntypedFormGroup, Validators, FormGroup, FormBuilder, FormArray, UntypedFormControl } from '@angular/forms';
import { UserServiceIndex } from 'src/app/shared/services/user.service';
import { GroupPaymentType } from 'src/app/shared/models/group-payment-type.model';
import { MessageServiceIndex } from 'src/app/shared/services/message.service';
import { Group } from 'src/app/shared/models/group.model';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { FranchiseService } from '../../services/franchise.service';
import { FranchiseCourseDesign } from '../../models/franchise-course-design.model';
import { FranchiseCourse } from '../../models/franchise-course.model';
import { Franchise } from '../../models/franchise.model';
import { CdkDragDrop, CdkDropList, CdkDrag, moveItemInArray } from '@angular/cdk/drag-drop';
import { UploadComponentQueueType } from 'src/app/groups/module/module.component';
import { UploadModel } from '../../models/upload.model';
import { CourseDesign } from '../../models/course-design.model';

export enum SectionType {
    Header = 'header',
    Intro = 'intro',
    FAQ = 'faq',
    Program = 'program',
    Form = 'form',
    Advantages = 'advantages',
    Footer = 'footer',
}

interface SectionFields {
    fields?: string[];
    items?: string[];
  }

  interface DesignCombinations {
    [key: string]: {
      [key: string]: SectionFields;
    };
  }

  interface PossibleCombinations {
    design: DesignCombinations;
  }

  interface DesignMapping {
    [key: number]: string;
  }

  const designMapping: DesignMapping = {
    1: 'standart',
    2: 'gray'
  };


@Component({
    selector: 'course-page-edit',
    templateUrl: './course-page-edit.component.html',
    styleUrls: ['./course-page-edit.component.scss']
})


export class CoursePageEdit {
    protected readonly PAGINATION_LIMIT: number = environment.pagination.default;
    protected readonly CACHING_MAX_TIME: number = environment.caching.default;

    protected innerLoadingQueue: number = 0;
    protected listSubscription?: Subscription;
    protected subscriptions: Subscription[] = [];
    protected debounceTimeout: number = 750;
    protected searchDebounce: any = null;

    franchiseId = this.route.snapshot.paramMap.get('id') as string;
    courseId = this.route.snapshot.paramMap.get('courseId') as string;
    loading: boolean = false;
    form: UntypedFormGroup|null = null;
    errors: any = {};
    conversationFilters: MessageServiceIndex = {
        limit: this.PAGINATION_LIMIT,
        page: 1,
        q: '',
    };
    usersFilter: UserServiceIndex & {loading: boolean} = {
        limit: this.PAGINATION_LIMIT,
        page: 1,
        q: '',
        loading: false,
        role: 'student',
    };
    selectedImage: any;
    search: string = '';
    filter: string = '';
    ingredient!: string;
    message: string = '';
    paymentTypeList?: Paginate<GroupPaymentType>;
    paymentTypes: Array<{id: number|null, name: string}> = [];
    showPaymentMenu: boolean = false;
    designOptions: FranchiseCourseDesign[] = [];

    user: User = new User;
    franchise: Franchise|null = null;

    student: User| null = null;
    group: Group|null = null;
    course: FranchiseCourse|null = null;
    design: CourseDesign|null = null;
    sectionTypes: string[]|null = null;
    selectedSectionIndex: number | null = null;
    selectedSection: number | null = null;
    selectedItemIndex: number | null = null;
    photo: any = null;
    messageType: ('error'|'success') = 'error';
    uploadIndex: number = 0;
    sectionTypeOptions: any = {};

    currentAllowedFieldsStatus: { [key: string]: boolean } = {};
    currentAllowedItemsStatus: { [key: string]: boolean } = {};
    canAddItems : boolean = false;

    possibleCombinations: PossibleCombinations = {
        design: {
            standart: {
                header: {},
                intro: {
                    fields: ['title','subtitle','description'],
                    items: [],
                },
                faq: {
                    fields: ['title','subtitle','description'],
                    items: ['title','description'],
                },
                program: {
                    fields: ['title','subtitle','description'],
                    items: ['image','alt','title','subscription','description'],
                },
                form: {
                    fields: ['title','subtitle','description'],
                },
                advantages: {
                    fields: ['title','subtitle','description'],
                    items: ['image','alt','title'],
                },
                footer: {},
            },
            gray: {
                header: {},
                intro: {
                    fields: ['title','subtitle','description'],
                },
                faq: {
                    fields: ['title','subtitle','description'],
                    items: ['title','description'],
                },
                program: {
                    fields: ['title','subtitle','description'],
                    items: ['image','alt','title','subscription','description'],
                },
                form: {
                    fields: ['title','subtitle','description'],
                },
                advantages: {
                    fields: ['title','subtitle','description'],
                    items: ['image','alt','title'],
                },
                footer: {},
            }
        }
    }

    set loadingQueue(value: number) {
        if (this.innerLoadingQueue !== value) {
            this.innerLoadingQueue = value;

            if (this.innerLoadingQueue <= 0) {
                this.innerLoadingQueue = 0;
                this.loading = false;
            } else {
                this.loading = true;
            }
        }
    }
    get loadingQueue(): number {
        return this.innerLoadingQueue;
    }

    constructor(
        private authService: AuthService,
        private formBuilder: FormBuilder,
        private messageService: MessageService,
        private route: ActivatedRoute,
        private franchiseService: FranchiseService,
        private router: Router,
    ) {
        this.sectionTypes = this.getSectionTypes(SectionType);
    }

    ngOnInit(): void {
        this.user = this.authService?.getUser() ?? new User();
        this.getCourse();
        this.initForm();
        this.getFranchise();
        this.getDesigns();
        this.sectionTypeOptions = this.getSectionTypeOptions();

        this.form?.get('design')?.valueChanges.subscribe(value => {
            this.updateAllowedFieldsAndItems();
        });

        this.sectionControls.valueChanges.subscribe(() => {
            this.updateAllowedFieldsAndItems();
        });

        this.updateAllowedFieldsAndItems();

    }

    ngOnDestroy(): void {
    }

    protected initForm() {
        this.form = this.formBuilder.group({
            url: new UntypedFormControl('', [Validators.required, Validators.maxLength(255)]),
            design: new UntypedFormControl(0),
            status: new UntypedFormControl(true),
            sections: this.formBuilder.array([]),
            selectedSection: this.formBuilder.group({
                title: [''],
                subtitle: [''],
                description: [''],
                thumbnail: [''],
                image: [''],
                alt: [''],
                type: [''],
                status: [''],
                position: ['']
            })
        });
    }

    get sectionControls(): FormArray {
        return this.form?.get('sections') as FormArray;
    }

    createSection(sectionData?: any): FormGroup {
        const sectionGroup = this.formBuilder.group({
            title: [sectionData?.title ?? '', [Validators.min(1), Validators.maxLength(255)]],
            subtitle: [sectionData?.subtitle ?? '', [Validators.min(1), Validators.maxLength(255)]],
            description: [sectionData?.description ?? '', [Validators.min(1), Validators.maxLength(1000)]],
            thumbnail: [sectionData?.thumbnail ?? '', [Validators.min(1), Validators.maxLength(255)]],
            image: [sectionData?.image ?? '', [Validators.min(1), Validators.maxLength(255)]],
            alt: [sectionData?.alt ?? '', [Validators.min(1), Validators.maxLength(255)]],
            type: [sectionData?.type ?? 'header'],
            status: [sectionData?.status ?? 'active'],
            position: [sectionData?.position ?? 1, [Validators.min(1), Validators.maxLength(10)]],
            items: this.formBuilder.array(sectionData?.items?.map((item:any) => this.createItem(item)) || [])
        });

        sectionGroup.get('type')?.valueChanges.subscribe(type => {
            if (type === 'header' || type === 'footer') {
                sectionGroup.get('title')?.setValue(type.charAt(0).toUpperCase() + type.slice(1));
            }
            else {
                sectionGroup.get('title')?.value === 'Header' || sectionGroup.get('title')?.value === 'Footer' ? sectionGroup.get('title')?.setValue('') : sectionGroup.get('title')?.value;
            }

            if (!this.canAddItems) {
                const items = sectionGroup.get('items') as FormArray;
                items.clear();
            }
        });

        if (sectionData?.type === 'header' || sectionData?.type === 'footer') {
            sectionGroup.get('title')?.setValue(sectionData.type.charAt(0).toUpperCase() + sectionData.type.slice(1));
        }

        sectionGroup.get('type')?.updateValueAndValidity();

        return sectionGroup;
    }

    createItem(itemData?: any): FormGroup {
        return this.formBuilder.group({
            title: [itemData?.title ?? '', [Validators.min(1), Validators.maxLength(255)]],
            subtitle: [itemData?.subtitle ?? '', [Validators.min(1), Validators.maxLength(255)]],
            description: [itemData?.description ?? '', [Validators.min(1), Validators.maxLength(1000)]],
            thumbnail: [itemData?.thumbnail ?? '', [Validators.min(1), Validators.maxLength(255)]],
            image: [itemData?.image ?? '',[Validators.min(1), Validators.maxLength(255)]],
            alt: [itemData?.alt ?? '', [Validators.min(1), Validators.maxLength(255)]],
            status: [itemData?.status ?? 'active'],
            position: [itemData?.position ?? 1, [Validators.min(1), Validators.maxLength(10)]]
        });
    }


    addSection(): void {
        const sections = this.form?.get('sections') as FormArray;
        sections.push(this.createSection());
    }

    addElement(): void {
    if (this.selectedSectionIndex === null) {
        return;
    }

        const section = (this.form?.get('sections') as FormArray).at(this.selectedSectionIndex) as FormGroup;
        const items = section.get('items') as FormArray;
        items.push(this.createItem());
    }

    selectItem(index: number): void {
        this.selectedItemIndex = index;
    }

    get selectedSectionItems(): FormArray {
        if (this.selectedSectionIndex !== null) {
            const section = this.sectionControls.at(this.selectedSectionIndex) as FormGroup;
            return section.get('items') as FormArray;
        }
        return this.formBuilder.array([]);
    }

    onSubmit(event?: Event): void {
        if (this.loading) {
            return;
        }


        if (this.form?.invalid) {
            this.errors = this.form?.controls;

            this.messageService.add({
                severity: 'error',
                summary: translate('Грешка!'),
                detail: translate('Моля, проверете полетата отново!'),
            });
            this.form.markAllAsTouched();

            return;
        }

        const formData = this.form?.getRawValue();

        formData.status = formData.status ? 'active' : 'inactive';
        formData.sections.forEach((section: any, sectionIndex: number) => {
            section.position = sectionIndex + 1;
            section.status = section.status ? 'active' : 'inactive';

            section.items.forEach((item: any, itemIndex: number) => {
                item.position = itemIndex + 1;
                item.status = item.status ? 'active' : 'inactive';

                item.thumbnail = item.thumbnail || '';
                item.image = item.image || '';
            });
        });

        if(formData['selectedSection']) {
            delete formData['selectedSection'];
        }


        this.loadingQueue++;
        const subscription = this.franchiseService.updateCourse(+this.franchiseId ?? 0, +this.courseId ?? 0, formData).subscribe({
            next: response => {
                this.loadingQueue--;

                this.messageService.add({
                    severity: 'success',
                    summary: translate('Успешно!'),
                    detail: translate('Успешно редактиран курс!'),
                });

                if(this.user?.role?.name === 'admin') {
                    this.router.navigateByUrl('/partners/' + this.franchiseId);
                }
                else {
                    this.router.navigateByUrl('/courses/' + this.courseId);
                }
            },
            error: error => {
                this.loadingQueue--;
                    this.messageService.add({
                        severity: 'error',
                        detail: error || translate("Възникна при редактиране на курс."),
                    });
                    this.errors = error;
            }
        });
        this.subscriptions.push(subscription);
    }

    protected getCourse(): void {
        const subscription = this.franchiseService.getCourse(+this.franchiseId ?? 0, +this.courseId ?? 0)
          .subscribe(response => {
            this.course = response.data;
            if(this.user?.role?.name === 'partner') {
                this.design = response.data?.design ?? null;
            }

            this.form?.patchValue({
              url: this.course.url,
              design: this?.user?.role?.name === 'admin' ? this.course?.design?.id : null,
              status: this.course.status === 'active'
            });

            while (this.sectionControls.length !== 0) {
                this.sectionControls.removeAt(0);
            }

            this.course?.sections?.forEach(section => {
              const sectionGroup = this.createSection({
                ...section,
                status: section.status === 'active'
              });
              this.sectionControls.push(sectionGroup);

              const itemsArray = sectionGroup.get('items') as FormArray;
              itemsArray.clear();

              section.items?.forEach(item => {
                const itemGroup = this.createItem({
                  ...item,
                  status: item.status === 'active'
                });
                itemsArray.push(itemGroup);
              });
            });
        });
        this.subscriptions.push(subscription);
    }


    protected getFranchise() {
        const subscription = this.franchiseService.getFranchise(+this.franchiseId ?? 0).subscribe({
            next: data => {
                this.franchise = data?.data;
            },
            error: error => {
                this.messageService.add({
                    severity: 'error',
                    detail: translate('Партньорът не съществува!'),
                });
            }
        });
        this.subscriptions.push(subscription);
    }

    protected getDesigns() {
        this.loadingQueue++;

        const subscription = this.franchiseService.getCourseDesigns().subscribe({
            next: data => {
                this.loadingQueue--;
                this.designOptions = data?.data;
            },
            error: error => {
                this.loadingQueue--;

                this.messageService.add({
                    severity: 'error',
                    detail: translate('Грешка при извличането на курсове!'),
                });
            }
        });
        this.subscriptions.push(subscription);
    }


    private getSectionTypes(enumObj: any): any[] {
        return Object.keys(enumObj).map(key => {
            return {
                id: enumObj[key],
                title: key
            };
        });
    }

    drop(event: CdkDragDrop<string[]>): void {
        moveItemInArray(this.sectionControls.controls, event.previousIndex, event.currentIndex);
        const sections = this.form?.get('sections')
        if(sections) {
            sections.setValue(this.sectionControls.controls.map(control => control.value));
        }

        this.selectSection(event.currentIndex);
    }

    selectSection(index: number): void {
        this.selectedSectionIndex = index;
        this.updateAllowedFieldsAndItems();
    }

    get selectedSectionFormGroup(): FormGroup {
        return this.sectionControls.at(this.selectedSectionIndex ?? 0) as FormGroup;
    }


    addItem(): void {
        if (this.selectedSectionIndex === null || !this.canAddItems) {
            return;
        }

        const items = this.selectedSectionItems;
        items.push(this.createItem());
    }

    dropItem(event: CdkDragDrop<any[]>): void {
        if (this.selectedSectionIndex !== null) {
            const items = this.selectedSectionItems;
            moveItemInArray(items.controls, event.previousIndex, event.currentIndex);
            items.setValue(items.controls.map(control => control.value));
        }
    }

    getFormGroupAtIndex(index: number): FormGroup {
        return this.selectedSectionItems.at(index) as FormGroup;
    }

    removeSection(index: number): void {
        this.sectionControls.removeAt(index);
    }

    removeItem(index: number): void {
        this.selectedSectionItems.removeAt(index);
    }



    onFileFinished(event: { files: UploadComponentQueueType<UploadModel>[] }, isThumbnail: boolean, sectionIndex: number, itemIndex?: number): void {
        if (!event.files || !event.files.length || event.files[0].error) {
            this.message = translate('Невалидна снимка, или файлът е твърде голям.');
            this.messageType = 'error';
            return;
        }

        const fileData = {
            path: event.files[0].response.data.path,
            url: event.files[0].response.data.url,
        };

        if (typeof itemIndex === 'number') {
            // It's an item upload
            const itemFormGroup = (this.sectionControls.at(sectionIndex) as FormGroup).get('items') as FormArray;
            const itemControl = itemFormGroup.at(itemIndex) as FormGroup;
            itemControl.get(isThumbnail ? 'thumbnail' : 'image')?.setValue(fileData.path);
        } else {
            // It's a section upload
            const sectionFormGroup = this.sectionControls.at(sectionIndex) as FormGroup;
            sectionFormGroup.get(isThumbnail ? 'thumbnail' : 'image')?.setValue(fileData.path);
        }
    }



    getPhotoUrl(isThumbnail: boolean, sectionIndex: number, itemIndex?: number): string {
        const section = this.sectionControls.at(sectionIndex) as FormGroup;
        if (typeof itemIndex === 'number') {
            const item = (section.get('items') as FormArray).at(itemIndex) as FormGroup;
            return item.get(isThumbnail ? 'thumbnail' : 'image')?.value;
        } else {
            return section.get(isThumbnail ? 'thumbnail' : 'image')?.value;
        }
    }

    removeFile(isThumbnail: boolean, sectionIndex: number, itemIndex?: number): void {
        const section = this.sectionControls.at(sectionIndex) as FormGroup;
        if (typeof itemIndex === 'number') {
            const item = (section.get('items') as FormArray).at(itemIndex) as FormGroup;
            item.get(isThumbnail ? 'thumbnail' : 'image')?.setValue('');
        } else {
            section.get(isThumbnail ? 'thumbnail' : 'image')?.setValue('');
        }
    }

    getSectionTypeOptions(): {label: string, value: string}[] {
        return Object.keys(SectionType).map(key => {
          return {
            label: key.charAt(0).toUpperCase() + key.slice(1),
            value: SectionType[key as keyof typeof SectionType]
          };
        });
    }

    private updateAllowedFieldsAndItems(): void {
        const designId = this.design?.id ?? this.form?.get('design')?.value;
        const designKey = designMapping[designId];
        const sectionType = this.selectedSectionFormGroup?.get('type')?.value;

        this.currentAllowedFieldsStatus = {};
        this.currentAllowedItemsStatus = {};
        this.canAddItems = false;

        if (designKey && sectionType) {
            const allowedFields = this.possibleCombinations.design[designKey]?.[sectionType]?.fields || [];
            const allowedItems = this.possibleCombinations.design[designKey]?.[sectionType]?.items || [];

            allowedFields.forEach(field => {
                this.currentAllowedFieldsStatus[field] = true;
            });

            allowedItems.forEach(item => {
                this.currentAllowedItemsStatus[item] = true;
            });

            this.canAddItems = allowedItems.length > 0;
        }
    }

    getSectionTitleDisplay(sectionType: string, index: number): string {
        const capitalizedType = sectionType.charAt(0).toUpperCase() + sectionType.slice(1);
        const sectionsOfType = this.sectionControls.controls.map(ctrl => ctrl.get('type')?.value);
        const typeCount = sectionsOfType.slice(0, index).filter(type => type === sectionType).length;

        return typeCount > 0 ? `${capitalizedType} ${typeCount + 1}` : capitalizedType;
    }

    getItemTitleDisplay(index: number): string {
        return `Item ${index + 1}`;
    }

}
